import { afterNextRender, booleanAttribute, DestroyRef, Directive, ElementRef, inject, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Directive({
    standalone: true,

    selector: '[id]',
    host: {
        class: 'scroll-mt-[50px]',
    },
})
export class AnchorDirective {
    route = inject(ActivatedRoute);
    elementRef: ElementRef<HTMLElement> = inject(ElementRef);
    destroyRef = inject(DestroyRef);

    id = input.required<string>();

    blockInitialScroll = input(false, { transform: booleanAttribute });

    constructor() {
        afterNextRender(async () => {
            if (this.blockInitialScroll()) {
                return;
            }

            const fragment = await firstValueFrom(this.route.fragment);
            if (fragment && fragment === this.id()) {
                this.elementRef.nativeElement.scrollIntoView();
            }
        });
    }
}
